const translations = {
  "en": {
    "Thinking": "Thinking"
  },
  "zh-tw": {
    "Thinking": "思考中"
  }
};

export default translations;
